import React from 'react'

const FamiliesSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.53846" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4461_1521)" />
    <g clipPath="url(#clip0_4461_1521)">
      <path
        d="M47.9774 36.7998H45.1184C45.3987 37.5846 45.5669 38.4815 45.5669 39.3224V50.0294C45.5669 50.3658 45.5108 50.7582 45.3987 51.0945H50.0515C51.7893 51.0945 53.1907 49.6931 53.1907 47.9553V42.0692C53.2468 39.1542 50.8924 36.7998 47.9774 36.7998Z"
        fill="white"
      />
      <path
        d="M38.2233 34.0529H31.7206C28.8056 34.0529 26.4512 36.4074 26.4512 39.3224V50.0294C26.4512 50.59 26.8996 51.0945 27.5163 51.0945H42.4277C42.9882 51.0945 43.4928 50.6461 43.4928 50.0294V39.3224C43.4928 36.4074 41.1383 34.0529 38.2233 34.0529Z"
        fill="white"
      />
      <path
        d="M34.972 20.0385C31.4964 20.0385 28.6375 22.8974 28.6375 26.373C28.6375 29.8486 31.4964 32.7075 34.972 32.7075C38.4476 32.7075 41.3065 29.8486 41.3065 26.373C41.3065 22.8974 38.5036 20.0385 34.972 20.0385Z"
        fill="white"
      />
      <path
        d="M46.1274 25.9806C43.4927 25.9806 41.4186 28.1108 41.4186 30.6895C41.4186 33.2681 43.5488 35.3983 46.1274 35.3983C48.7061 35.3983 50.8363 33.2681 50.8363 30.6895C50.8363 28.0547 48.7061 25.9806 46.1274 25.9806Z"
        fill="white"
      />
      <path
        d="M22.0226 36.7998H24.8816C24.6013 37.5846 24.4331 38.4815 24.4331 39.3224V50.0294C24.4331 50.3658 24.4892 50.7582 24.6013 51.0945H19.8924C18.1546 51.0945 16.7532 49.6931 16.7532 47.9553V42.0692C16.7532 39.1542 19.1076 36.7998 22.0226 36.7998Z"
        fill="white"
      />
      <path
        d="M23.8726 25.9806C26.5073 25.9806 28.5814 28.1108 28.5814 30.6895C28.5814 33.2681 26.4512 35.3983 23.8726 35.3983C21.2939 35.3983 19.1637 33.3242 19.1637 30.6895C19.1637 28.0547 21.2939 25.9806 23.8726 25.9806Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4461_1521"
        x1="34.5455"
        y1="0.53846"
        x2="34.5455"
        y2="70.5385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49912D" />
        <stop offset="1" stopColor="#33691E" />
      </linearGradient>
      <clipPath id="clip0_4461_1521">
        <rect width="36.4937" height="31" fill="white" transform="translate(16.7532 20.0385)" />
      </clipPath>
    </defs>
  </svg>
)

export default FamiliesSubcategory
